export class AccountOTPInfo {
    public AccountName: string;
    public Email: string;
    public MobilePhoneNr: string;
    public MobilePhonePrefix: string;
    public TwoFactorType: number;
    public TOTPConfigured: boolean;

    constructor() {}

    assign(accountInfo?: AccountOTPInfo) {
        this.AccountName = accountInfo.AccountName;
        this.Email = accountInfo.Email;
        this.MobilePhoneNr = accountInfo.MobilePhoneNr;
        this.MobilePhonePrefix = accountInfo.MobilePhonePrefix;
        this.TwoFactorType = accountInfo.TwoFactorType;
        this.TOTPConfigured = accountInfo.TOTPConfigured;
    }
}

export class OTPViaSMSInfo {
    public AccountName: string;
    public InternationalPrefix: string;
    public PhoneNumber: string;
    public Otp: string;

    constructor() {}

    assign(accountInfo?: OTPViaSMSInfo) {
        this.AccountName = accountInfo.AccountName;
        this.InternationalPrefix = accountInfo.InternationalPrefix;
        this.PhoneNumber = accountInfo.PhoneNumber;
        this.Otp = accountInfo.Otp;
    }
}

export enum TwoFactorType {
    None = 0, //NON PERMESSO
    SMS = 1,
    Email = 2, //DEFAULT
    TOTP = 4,
}
